import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$companySlug/fleets/$fleetId')({
  beforeLoad: ({ context, params }) => {
    context.auth.rejectIfMissingPermissions(['SITE_READ'])

    if (!context.company.hasSite(params.fleetId)) {
      throw redirect({
        to: '/forbidden',
        search: { redirect: location.href }
      })
    }
  },
  component: FleetId,
  head: () => ({
    meta: [{ title: 'Fleet Management' }]
  })
})

function FleetId() {
  // TODO: Add fleet context for deeper components and check for authentication of the fleet

  return <Outlet></Outlet>
}
